"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsersListItem = exports.ModalScrollBody = exports.ModalFooter = exports.ModalTitleCount = exports.ModalTitle = exports.StyledModal = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _modal = _interopRequireDefault(require("antd/lib/modal"));

require("antd/lib/modal/style/index.css");

var _StyledLayout = require("../../StyledLayout");

var _StyledUserAvatar = require("../../StyledUserAvatar");

var _StyledTypography = require("../../StyledTypography");

var _StyleGuide = require("../../StyleGuide");

var _MediaQueries = _interopRequireDefault(require("../../MediaQueries"));

var _CloseButton = _interopRequireDefault(require("../../CloseButton"));

require("./StyledModal.scss");

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledModal = (0, _styledComponents["default"])(_modal["default"]).withConfig({
  displayName: "StyledModal",
  componentId: "sc-1jl2l3z-0"
})(["&.ant-modal{box-shadow:none;padding-bottom:0px;margin:0;width:450px;max-height:100%;max-width:100% !important;@media (max-width:450px){height:100%;flex:1 !important;.ant-modal-content{border-radius:0;}}}.ant-modal-title{height:40px;display:flex;align-items:center;justify-content:center;}.ant-modal-content{box-shadow:", ";font-family:", ";border-radius:", ";padding:", ";height:100%;}.ant-modal-body{padding:0;text-align:", ";height:100%;}.ant-modal-close{left:0;}.ant-modal-close-x{", ";}.ant-modal-header{border:0;padding:0;padding-bottom:", ";}@media (min-width:", "px) and (max-width:767px){&.ant-modal{width:", "px !important;}}", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.theme.boxShadowLg;
}, function (props) {
  return props.theme.fontFamilyDefault;
}, function (props) {
  return props.theme.borderRadiusMd;
}, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.textAlign;
}, _CloseButton["default"], function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.width;
}, function (props) {
  return props.width;
}, function (props) {
  return props.width && (0, _styledComponents.css)(["@media (max-width:", "px){&.ant-modal{flex:1 !important;}.ant-modal-content{border-radius:0;}}"], props.width);
}, function (props) {
  return props.large && (0, _styledComponents.css)(["&.ant-modal{max-height:100%;}", " ", ""], _MediaQueries["default"].minWidth.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n      &.ant-modal {\n        width: 620px;\n      }\n    "]))), _MediaQueries["default"].minWidth.large(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n      &.ant-modal {\n        width: 922px;\n      }\n    "]))));
}, function (props) {
  return props.infiniteScroll && (0, _styledComponents.css)([".ant-modal-content{padding-bottom:0;}"]);
}, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(["&.ant-modal{width:100% !important;padding:0 ", ";", "}"], props.theme.spacingSm, _MediaQueries["default"].minWidth.medium(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        padding: 0 ", ";\n      "])), props.theme.spacingLg));
}, function (props) {
  return props.fullscreen && (0, _styledComponents.css)(["&.ant-modal,.ant-modal-content,.ant-modal-body{width:100% !important;height:100%;max-width:100%;}"]);
}, function (props) {
  return props.noPadding && (0, _styledComponents.css)([".ant-modal-content{padding:0;}"]);
}, function (props) {
  return (props.noShadow || props.fullscreen) && (0, _styledComponents.css)(["&.ant-modal{box-shadow:none;}.ant-modal-content{box-shadow:none;.anticon{display:none !important;}}"]);
});
exports.StyledModal = StyledModal;
var ModalTitle = (0, _styledComponents["default"])(_StyledTypography.HeadingSmall).attrs(function () {
  return {
    inline: true
  };
}).withConfig({
  displayName: "StyledModal__ModalTitle",
  componentId: "sc-1jl2l3z-1"
})([""]);
exports.ModalTitle = ModalTitle;
var ModalTitleCount = (0, _styledComponents["default"])(_StyledTypography.HeadingSmall).attrs(function () {
  return {
    inline: true,
    mediumGrey: true,
    normal: true
  };
}).withConfig({
  displayName: "StyledModal__ModalTitleCount",
  componentId: "sc-1jl2l3z-2"
})([""]);
exports.ModalTitleCount = ModalTitleCount;

var ModalFooter = _styledComponents["default"].div.withConfig({
  displayName: "StyledModal__ModalFooter",
  componentId: "sc-1jl2l3z-3"
})(["display:flex;justify-content:space-around;padding-top:", ";"], function (props) {
  return props.theme.spacingLg;
}); // Must be used with standard ModalTitle


exports.ModalFooter = ModalFooter;
var ModalScrollBody = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "StyledModal__ModalScrollBody",
  componentId: "sc-1jl2l3z-4"
})(["min-height:248px;max-height:670px;overflow-y:auto;", ";@media (max-height:728px){max-height:calc(100vh - 58px);}@media (max-width:450px){max-height:calc(100vh - 55px);}"], _StyleGuide.hideScrollbar);
exports.ModalScrollBody = ModalScrollBody;
var UsersListItem = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "StyledModal__UsersListItem",
  componentId: "sc-1jl2l3z-5"
})(["display:flex;align-items:center;justify-content:space-between;margin-top:", ";&:first-of-type{margin-top:0;}&:last-of-type{margin-bottom:", ";}", "{font-size:", ";}"], function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.spacingSm;
}, _StyledUserAvatar.UserAvatarName, function (props) {
  return props.theme.fontSizeBodySm;
});
exports.UsersListItem = UsersListItem;